export interface ImageProps {
  id: string;
  url: string;
  fileName: string;
  altText?: string | null;
  mimeType: string;
  size: number;
  createdAt: string;
  updatedAt: string;
}

export class ImageEntity {
  public readonly id: string;
  public readonly url: string;
  public readonly fileName: string;
  public readonly altText?: string | null;
  public readonly mimeType: string;
  public readonly size: number;
  public readonly createdAt: string;
  public readonly updatedAt: string;

  constructor(props: ImageProps) {
    this.id = props.id;
    this.url = props.url;
    this.fileName = props.fileName;
    this.altText = props.altText;
    this.mimeType = props.mimeType;
    this.size = props.size;
    this.createdAt = props.createdAt;
    this.updatedAt = props.updatedAt;
  }

  public get formattedSize(): string {
    if (!this.size) return '0 KB';
    if (this.size < 1024) return `${this.size} B`;
    if (this.size < 1024 * 1024) return `${(this.size / 1024).toFixed(1)} KB`;
    return `${(this.size / (1024 * 1024)).toFixed(2)} MB`;
  }

  public get isLocalUpload(): boolean {
    return this.url.startsWith('/uploads/') || this.url.startsWith('uploads/');
  }
}
